<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div :class="this.type==='changePassword' || this.type==='resetPassword'?'backgroud-gray-popup popup-content-area-small':'backgroud-gray-popup popup-content-area'">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item v-if="this.type==='changePassword'" prop="oldPassword" label="原密码" label-width="100px" class="label-strong">
          <el-input @change='checkAllInputs' placeholder="请输入原密码" type="password" v-model="form.oldPassword">
          </el-input>
        </el-form-item>
        <el-form-item prop="phoneType" v-if="this.type==='forgotPassword'" label="手机号码" label-width="100px" class="label-strong">
          <el-select @change='checkAllInputs' v-model="form.phoneType" placeholder="请选择">
            <el-option v-for="item in phoneTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="phone" v-if="this.type==='forgotPassword'" label-width="100px" class="label-strong">
          <el-input @change='checkAllInputs' placeholder="请输入手机号码" v-model="form.phone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item v-if="this.type==='forgotPassword'" label="  " label-width="100px">
          <el-button :disabled="smsBtnDisable" :type="smsBtnClass" @click="smsBtnClick" class="smsBtn">{{smsBtnText}}</el-button>
          <span>收不到验证码</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <div slot="content">请确认输入的手机号码为10位数<br/>北美手机号或11位数中国手机号，<br/>若还是无法收到验证码，请联系客服</div>
            <img src="../assets/question.png">
          </el-tooltip>
        </el-form-item>
        <el-form-item v-if="this.type==='forgotPassword'" prop="code" label="验证码" class="label-strong" label-width="100px">
          <el-input @change='checkAllInputs' placeholder="请输入收到的验证码" v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="新密码" label-width="100px" class="label-strong">
          <el-input @change='checkAllInputs' placeholder="请设置登录密码" type="password" v-model="form.password">
          </el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="重复密码" label-width="100px" class="label-strong">
          <el-input @change='checkAllInputs' placeholder="请再次输入登录密码" type="password" v-model="form.confirmPassword">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="16" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="8">
          <el-button :type="submitBtnClass" @click="save()">确认修改</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getPhoneTypeList } from "../service/api-base.service";
import { getStore, setStore } from "../config/mUtils";
import { sendSMS } from "../service/common.service";
import { validatePhoneAndCode } from "../service/student.service";
import { resetPassword, userLogin } from "../service/user.service";
import elScsPassword from "./common/el-scs-password";

export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      let isValid = value.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
      );
      if (!isValid) {
        callback(new Error("密码需为8位长度的大小写字母和数字"));
      } else {
        callback();
      }
    };

    var validatePhone = (rule, value, callback) => {
      let message = "";
      if (!value) {
        message = "请输入手机号码";
      } else {
        if (this.form.phoneType == 1) {
          if (value.length != 10) {
            message = "请输入10位数北美手机号";
          }
        } else {
          if (value.length != 11) {
            message = "请输入11位数中国手机号";
          }
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isSendSMS: false,
      timer: null,
      showError: false,
      errorMessage: "",
      smsBtnDisable: true,
      submitBtnClass: "info",
      smsBtnClass: "info",
      smsBtnText: " 发送验证码 ",
      token: "",
      phoneTypeList: [],
      form: {
        phoneType: 1,
        phone: "",
        studentId: 0,
        oldPassword: "",
        password: "",
        confirmPassword: "",
        code: ""
      },
      rules: {
        phoneType: [
          {
            required: true,
            message: "请选择号码归属地",
            trigger: "blur"
          }
        ],
        oldPassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
        phone: [
          // {
          //   required: true,
          //   message: "请输入手机号码",
          //   trigger: "blur"
          // },
          // {
          //   min: 0,
          //   max: 10,
          //   message: "最大长度在为10个字符",
          //   trigger: "blur"
          // }
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ]
      }
    };
  },
  props: ["type", "studentId"],
  components: {
    elScsPassword
  },
  created() {
    this.form.studentId = getStore("user_student_id");
    this.phoneTypeList = getPhoneTypeList();
  },
  methods: {
    checkFieldValidate(fieldName) {
      let fieldValid = true;
      this.$refs["form"].validate((valid, elements) => {
        if (fieldName in elements) {
          fieldValid = false;
        }
      });
      return fieldValid;
    },
    checkAllInputs() {
      if (!this.isSendSMS) {
        if (this.checkFieldValidate('phone')){
          this.setSMSBtnState(false);
        } else {
          this.setSMSBtnState(true);
        }
      }

      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (isValid) {
        this.submitBtnClass = "primary";
      } else {
        this.submitBtnClass = "info";
      }
    },
    async checkOldPassword() {
      let loginType = this.GLOBAL.loginType.speedup.name;
      if (this.USERMANAGER.isStudent){
        loginType = this.GLOBAL.loginType.student.name;
      }
      let result = await userLogin(
        getStore("user_name"),
        this.form.oldPassword,
        loginType
      );
      if (result) {
        if (!result.success) {
          this.errorMessage = "您输入的原密码不正确";
          this.showError = true;
          return false;
        }
        this.checkAllInputs();
        return true;
      }
      return false;
    },
    async checkPhoneAndCode() {
      let result = await validatePhoneAndCode(this.form.phone, this.form.code);
      if (result) {
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
          return false;
        } else {
          //console.log("result.data", result.data);
          setStore("auth_token", result.data);
        }
        return true;
      }
    },
    async save() {
      this.showError = false;
      this.errorMessage = "";

      let valid = true;
      this.$refs.form.validate(v => {
        if (!v) {
          valid = false;
        }
      });
      if (!valid) return;
      let resetType = 1;
      if (this.type === "changePassword") {
        let oldPassCheck = await this.checkOldPassword();
        if (!oldPassCheck) return;
      } else if (this.type === "forgotPassword") {
        let checkPhoneAndCode = await this.checkPhoneAndCode();
        if (!checkPhoneAndCode) return;
      } else if (this.type == "resetPassword"){
        this.form.studentId = this.studentId;
        resetType = 2;
      }else {
        return;
      }

      let result = await resetPassword(this.form,resetType);
      if (result) {
        //console.log("resetPassword", result);
        if (!result.success) {
          this.errorMessage = result.message;
          this.showError = true;
        } else {
          this.showError = false;
          this.$refs.form.resetFields();

          let message = "密码重置成功！";
          if (this.type === "forgotPassword") {
            message = "密码重置成功，请重新登录！";
          }
          this.$message({
            message: message,
            type: "success"
          });
          this.$emit("closeEditor", "password");
        }
      }
    },
    setSMSBtnState(isDisable) {
      if (isDisable) {
        this.smsBtnDisable = true;
        this.smsBtnClass = "info";
      } else {
        this.smsBtnDisable = false;
        this.smsBtnClass = "primary";
      }
    },
    afterSMSSend() {
      this.isSendSMS = true;
      this.setSMSBtnState(true);
      let count = 60;
      this.smsBtnText = count.toString() + "秒后重新发送";

      let self = this;
      if (self && !self._isDestroyed) {
        self.timer = setInterval(() => {
          if (self && !self._isDestroyed) {
            count--;
            if (count == 0) {
              this.isSendSMS = false;
              this.setSMSBtnState(false);
              this.smsBtnText = " 发送验证码 ";
              clearInterval(self.timer);
            } else {
              this.smsBtnText = count.toString() + "秒后重新发送";
            }
          }
        }, 1000);
      }
    },
    async smsBtnClick() {
      if (this.isSendSMS) return;
      let sendResult = await this.sendRegisterSMS();
      if (!sendResult) {
        return;
      }
    },
    async sendRegisterSMS() {
      let isSuccess = false;
      if (!this.checkFieldValidate("phone")) {
        this.$message({
          message: "请先输入有效的电话号码！",
          type: "warning"
        });
        return false;
      }
      await sendSMS(this.form.phone, 3).then(result => {
        if (!!result) {
          if (result.success == true) {
            this.$message("验证码发送成功，请注意查收！");
            isSuccess = true;
            this.afterSMSSend();
          } else {
            if (result.message) {
              this.$message({
                message: result.message,
                type: "error"
              });
            }
          }
        }
      });
      return isSuccess;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/passwordEditor.vue